module.exports = __webpack_public_path__ + "img/light-file-icon.97f9604c.svg";